










/* Created- 23 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentSearchHit } from "../../../Generated/ParticaAPI";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../../Models/Buttons";


@Component(
	{
		name: "ArticleNavActions",
		components: { ButtonList, ParticaCard }
	})
export default class ArticleNavActions extends Vue {
	@Prop() private article: ContentSearchHit; // your data        
	private buttons: ButtonConfig[] = [
		{
			label: "Go to issue",
			action: eParticaAction.ISSUE_SELECT,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Go to Account",
			action: eParticaAction.ADMIN_SELECT_ACCOUNT,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Close",
			action: eParticaAction.CLOSE_DIALOG,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private clicked(event: ParticaEvent) {
		event.item = this.article;
		this.$emit("partica-event", event);
	}
}
